import * as React from "react";
import type { SVGProps } from "react";
const SvgSortVertical01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.6 15.6 12 19.2l-3.6-3.6m0-7.2L12 4.8l3.6 3.6"
    />
  </svg>
);
export default SvgSortVertical01;
